<script setup>
import ProfileNavbar from "../Navbar/ProfileNavbar.vue";
import FullscreenNavbar from "../Navbar/FullscreenNavbar.vue";
import SearchNavbar from "../Navbar/SearchNavbar.vue";
import BtntoogleNavbar from "./BtntoogleNavbar.vue";
import ColorMode from '@/components/ColorMode.vue';
import { useAuthStore } from '@/stores/auth.js';
import { computed } from "vue";
import { useRoute } from "vue-router";
const authStore = useAuthStore();

const route = useRoute();

const path = computed(() => {
  return route.name;
});
</script>

<template>
  <header class="fixed-top navlight">
    <!-- Nav header -->
    <div class="nav-header">
      <a class="navbar-brand" href="/">
        <h3>
          <span class="text-danger">Medical</span>
          <span class="text-dark-emphasis">Dhara</span>
        </h3>
      </a>
      <BtntoogleNavbar v-if="!path.includes('hojagastos')" />
    </div>

    <!-- Header content -->
    <div class="header">
      <div class="header-content">
        <!-- Navbar for large screens -->
        <nav class="navbar navbar-expand-lg">
          <div class="container-fluid">
            <div class="collapse navbar-collapse justify-content-between" id="navbarNav">
              <div class="header-left">
                <!-- <SearchNavbar /> -->
              </div>
              <ul class="navbar-nav">
                <li class="nav-item py-2 py-lg-1 col-12 col-lg-auto">
                  <div class="vr d-none d-lg-flex h-100 mx-lg-2 text-dark-emphasis"></div>
                </li>
                <ColorMode />
                <FullscreenNavbar />
                <li class="nav-item py-2 py-lg-1 col-12 col-lg-auto">
                  <div class="vr d-none d-lg-flex h-100 mx-lg-2 text-dark-emphasis"></div>
                </li>
                <li v-if="authStore.device" class="nav-item d-flex align-items-center me-3">
                  <i class="fa fa-desktop me-1"></i>
                  {{ authStore?.device?.nombre }}
                </li>
                <ProfileNavbar v-if="authStore && authStore.authUser" />
              </ul>
            </div>
          </div>
        </nav>

        <!-- Navbar for small screens -->
        <nav class="navbar navbar-expand d-lg-none">
          <div class="container-fluid">
            <div class="collapse navbar-collapse flex-row-reverse py-1" id="navbarNav">
              <ul class="navbar-nav align-items-center">
                <ColorMode />
                <li>
                  <ProfileNavbar v-if="authStore && authStore.authUser" />
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<style scoped>
@keyframes dropdownAnimation {
  from {
    opacity: 0;
    transform: translate3d(0, -30px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

/* Ajuste para nav-header sin fondo, altura ajustada */
.nav-header {
  width: 8rem;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;
  z-index: 10;
  box-sizing: border-box;
  min-height: 40px;
  /* background-color eliminado para no tener fondo */
}

.nav-header a.navbar-brand {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  height: auto;
}

.nav-header a.navbar-brand h3 {
  margin: 0;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1;
  display: flex;
  align-items: center;
}

/* Ajustes generales */
.header {
  padding: 0;
  padding-left: 14rem;
  transition: all 0.2s ease;
}

.header-left {
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.header .navbar {
  padding: 0;
  width: 100%;
}

.dropdown-menu {
  animation-name: dropdownAnimation;
  animation-duration: 0.25s;
  animation-fill-mode: both;
}

header.fixed-top {
    top: 0;
    height: 40px;
    z-index: 1040;
    background: var(--bs-body-bg);
}

.navlight {
    isolation: isolate;
}
</style>
